import React from 'react'

import { Text } from '../../typography/text'
import { EmptyScreenProps } from './empty-screen.types'

export const EmptyScreen: React.FC<EmptyScreenProps> = ({
  title,
  description,
  image,
  showButton = false,
  button,
  classNames,
}) => {
  return (
    <div
      className={`my-auto mt-32 flex w-full flex-col content-center justify-center ${
        classNames?.main || ''
      }`}
    >
      <div className={`mx-auto mb-2 ${classNames?.heading || ''}`}>
        <Text label={title} type="title" />
      </div>

      {description && (
        <div
          className={`mx-auto mb-2 text-base${classNames?.description || ''}`}
        >
          <Text label={description} type="body" />
        </div>
      )}

      {showButton && (
        <div
          className={`mx-auto mb-2 ${classNames?.buttons || ''}`}
          style={{ margin: window.innerWidth <= 965 ? '16px 0px' : 16 }}
        >
          {button}
        </div>
      )}

      <img
        src={image}
        className={`mx-auto h-auto w-60 md:w-96 ${classNames?.image || ''}`}
        alt={title}
      />
    </div>
  )
}
